export const UPDATE_USER_INFO = "updateUserInfo"
export const UPDATE_USER_PORTFOLIO = "updatePortfolio"
export const UPDATE_PORTOLIO_FILTER = "updatePortfolioFilter"
export const UPDATE_USER_PROFILE = "updateUserProfile"